import { render, staticRenderFns } from "./ListSupplierPage.vue?vue&type=template&id=04ac1126"
import script from "./ListSupplierPage.vue?vue&type=script&lang=js"
export * from "./ListSupplierPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports